import React, { useEffect, useState, useRef } from "react";
import api from "../../../api";
import PDFGenerator from "../../../components/PDFGenerator/PDFGenerator";
import { jsPDF } from "jspdf";


const CourseOutcomeWiseReports = ({ uid }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [selectedYear, setSelectedYear] = useState("");
  const [Coursedata, setCoursedata] = useState([]);

  const tableRefs = useRef([]);

  const addToRefs = (el) => {
    if (el && !tableRefs.current.includes(el)) {
      tableRefs.current.push(el);
    }
  };

  // Fetch academic years on component mount
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await api.get(`/api/users/getacademicyear/${uid}`);
        setData(res.data);
      } catch (err) {
        console.error("Error fetching academic years:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [uid]);

  // Fetch course data whenever selectedYear changes
  useEffect(() => {
    if (!selectedYear) return;

    const CourseChange = async () => {
      try {
        setLoading(true);
        const res = await api.get(`/api/reports/courseoutcome/${uid}`, {
          params: { selectedYear }, // Pass the selectedYear as query params
        });
        setCoursedata(res.data);
      } catch (err) {
        console.error("Error fetching course data:", err);
      } finally {
        setLoading(false);
      }
    };

    CourseChange();
  }, [selectedYear, uid]);

  // Group data by course code and course name
  const groupedData = Coursedata.reduce((acc, item) => {
    const key = `${item.coursecode} ${item.course_name}`;
    if (!acc[key]) {
      acc[key] = { courseDetails: item, outcomes: [] };
    }
    acc[key].outcomes.push(item);
    return acc;
  }, {});

  const groupedDataArray = Object.values(groupedData);

  const generatePDF = async () => {

    const headerNav = document.getElementById("header_nav");
    if (headerNav) {
      headerNav.style.display = "none";
    }

    const downloadButton = document.getElementById("downloadButton");
    if (downloadButton) {
      downloadButton.style.display = "none";
    }

    const img_h = document.getElementById("banner_for_output");
    if (img_h) {
      img_h.style.display = "block";
      img_h.style.width = "100%";
    }

    const resetStyles = () => {
      if (headerNav) {
        headerNav.style.display = ""; // Reset to original or default style
      }
  
      if (img_h) {
        img_h.style.display = "None"; // Reset to original or default style
        img_h.style.width = ""; // Reset to original or default style
      }

      if (downloadButton) {
        downloadButton.style.display = "";
      }
  
      // Remove the event listener to avoid memory leaks
      window.onafterprint = null;
    };
  
    window.onafterprint = resetStyles;

    window.print();
  
  };

  return (
    <div className="w-full">
      <img id="banner_for_output" style={{display:'None'}} src="/images/CollegeHeader.png" alt="" />
      
    
    <div className="w-full mt-8">
      <h1 className="text-2xl font-bold mb-6 text-center">
        Course Outcome Wise Reports
      </h1>
      {loading ? (
        <p className="text-blue-500 text-center">Loading academic years...</p>
      ) : (
        <div className="w-full max-w-md mx-auto mb-8">
          <label
            htmlFor="academicYear"
            className="block text-sm font-medium text-gray-700 mb-2"
          >
            Select Academic Year:
          </label>
          <select
            id="academicYear"
            value={selectedYear}
            onChange={(e) => setSelectedYear(e.target.value)}
            className="block w-full p-2.5 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="" disabled>
              -- Select Academic Year --
            </option>
            {data.map((item, index) => (
              <option key={index} value={item.academic_year}>
                {item.academic_year}
              </option>
            ))}
          </select>
        </div>
      )}

      {groupedDataArray.length > 0 && (
        <div className="overflow-x-auto"  ref={addToRefs} >
          <table className="min-w-full border-collapse border border-gray-300">
            <thead>
              <tr className="bg-purple-800 text-white">
                <th className="border border-gray-300 px-4 py-2">Sr. No.</th>
                <th className="border border-gray-300 px-4 py-2">
                  Course Code With Course
                </th>
                <th className="border border-gray-300 px-4 py-2">
                  Course Outcomes
                </th>
                <th className="border border-gray-300 px-4 py-2">
                  CO Attainment
                </th>
              </tr>
            </thead>
            <tbody>
              {groupedDataArray.map((group, groupIndex) => (
                <React.Fragment key={groupIndex}>
                  {group.outcomes.map((item, outcomeIndex) => (
                    <tr
                      key={outcomeIndex}
                      className={
                        outcomeIndex % 2 === 0
                          ? "bg-purple-200"
                          : "bg-purple-100"
                      }
                    >
                      {outcomeIndex === 0 && (
                        <>
                          <td
                            className="border border-gray-300 px-4 py-2 text-center"
                            rowSpan={group.outcomes.length}
                          >
                            {groupIndex + 1}
                          </td>
                          <td
                            className="border border-gray-300 px-4 py-2"
                            rowSpan={group.outcomes.length}
                          >
                            {group.courseDetails.coursecode}{" "}
                            {group.courseDetails.course_name}
                          </td>
                        </>
                      )}
                      <td className="border border-gray-300 px-4 py-2">
                        {item.co_name}
                      </td>
                      <td className="border border-gray-300 px-4 py-2 text-center">
                        {item.co_attainment}
                      </td>
                    </tr>
                  ))}
                </React.Fragment>
              ))}
            </tbody>
          </table>
          <button
          id="downloadButton"
        onClick={generatePDF}
        className="bg-purple-600 mt-4 text-white px-4 py-2 rounded hover:bg-purple-700"
      >
        Download PDF
      </button>
        </div>
      )}

     
    </div>
    </div>
  );
};

export default CourseOutcomeWiseReports;
